import React from 'react'

const PreviousLearners = () => {
  return (
    <div>PreviousLearners</div>
  )
}

export default PreviousLearners